import(/* webpackMode: "eager", webpackExports: ["Alert"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Alert/Alert.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Badge/Badge.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Button/Button.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Card/Card.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Grid"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Grid/Grid.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["GridCol"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Grid/GridCol/GridCol.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Group"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Group/Group.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["List"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/List/List.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ListItem"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/List/ListItem/ListItem.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Tabs/Tabs.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["TabsList"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Tabs/TabsList/TabsList.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["TabsPanel"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Tabs/TabsPanel/TabsPanel.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["TabsTab"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Tabs/TabsTab/TabsTab.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Title/Title.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Tooltip/Tooltip.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/app/mentors/[handle]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ProfilePageWrapper"] */ "/home/runner/work/web/web/src/app/mentors/[handle]/ProfilePageWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileViewTracker"] */ "/home/runner/work/web/web/src/app/mentors/[handle]/ProfileViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/home/runner/work/web/web/src/components/Avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BioWithEmbeds"] */ "/home/runner/work/web/web/src/components/BioWithEmbeds.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingAvatarsBackground"] */ "/home/runner/work/web/web/src/components/FloatingAvatarsBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/MentorCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkedInShareButton"] */ "/home/runner/work/web/web/src/components/ui/LinkedInShareButton.tsx");
